
<div class="flex-display" aria-label="CrossReferenceFeature-landingpage">
  <div class="float-L width-86">
    <div class="pr-96px pr-1-25">
      <div class="pcform pr-1-25">
        <h1 class="sub-heading margin-0 content-blue bold itcHeavyFont" role="heading" tabindex="0">{{crf_header}}</h1>
        <p class="answer font-16 content-blue width-100" [innerHTML]="crf_subtitle" tabindex="0"></p>
        <h2 class="topic-heading font-18 content-blue mt-2 bold" role="heading" tabindex="0">{{crf_bystandardheader}}</h2>
        <p class="answer font-16 content-blue width-100" [innerHTML]="crf_bystandardbody" appHostListenerClick> tabindex="0"</p>
        <h2 class="topic-heading font-18 content-blue mt-2  bold" role="heading" tabindex="0">{{crf_bycodificationheader}}</h2>
        <p class="answer font-16 content-blue width-100 pb-2rem" [innerHTML]="crf_bycodificationbody" tabindex="0"></p>
      </div>
    </div>
  </div>
</div>
